export default "__VITE_ASSET__e1bab33f__"